// src/components/strumenti/VelocitaFluido.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function VelocitaFluido() {
  const [portata, setPortata] = useState("");
  const [diametro, setDiametro] = useState("");

  const Q = (leggiNumero(portata)||0) / 60000; // l/min -> m³/s
  const D = (leggiNumero(diametro)||0) / 1000; // mm -> m
  const area = D>0 ? Math.PI * Math.pow(D/2, 2) : 0;
  const velocita = area>0 ? Q/area : null;

  const fuoriRange = velocita!==null && (velocita<0.5 || velocita>2);

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Portata (l/min)</label>
          <input value={portata} onChange={e=>setPortata(e.target.value)} style={inp} placeholder="Es. 30"/>
        </div>
        <div>
          <label style={lbl}>Diametro interno tubo (mm)</label>
          <input value={diametro} onChange={e=>setDiametro(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
      </div>

      <div style={{ background: fuoriRange ? "#fffbeb" : "#eff6ff", border:`1px solid ${fuoriRange?"#fde68a":"#bfdbfe"}`, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Velocità del fluido</div>
        <div style={{ fontSize:22, fontWeight:800, color: fuoriRange ? "#d97706" : "#2563eb" }}>
          {velocita===null ? "—" : velocita.toLocaleString("it-IT",{maximumFractionDigits:2})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>m/s</span>
        </div>
        {fuoriRange && (
          <div style={{ fontSize:11, color:"#92400e", marginTop:6 }}>Fuori dall'intervallo tipico consigliato (0,5–2 m/s per acqua) — verificare il dimensionamento</div>
        )}
      </div>

      <button onClick={()=>{setPortata("");setDiametro("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
